import React, { useState, useRef } from 'react';
import '../Product/newProductStyle.css';
import 'bootstrap/dist/css/bootstrap.min.css';

const ProductPage = () => {
    // ========== DATA START ==========

    // Assist Buddi Modules Data - 8 modules with SVG icons
    const assistBuddiModules = [
        {
            title: "Customer Support",
            icon: (
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
                </svg>
            ),
            benefit: "Unified ticket management, real-time live chat, and AI-driven automation",
            features: [
                "Unified ticket management system",
                "Real-time live chat support",
                "AI-driven automation for faster resolutions",
                "Actionable analytics dashboard",
                "Multi-channel support integration",

            ],
            sidebarTitle: "Customer Support",
            sidebarDescription: "Simplify customer support with unified ticket management, real-time live chat, AI-driven automation, and actionable analytics — all designed to deliver faster resolutions and superior customer experiences.",
            websiteUrl: "https://www.assistbuddi.com/customer-support"
        },
        {
            title: "Business Management",
            icon: (
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
                    <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
                </svg>
            ),
            benefit: "Simplify invoicing, inventory, payments, and GST compliance for Indian SMEs",
            features: [
                "Smart invoicing & billing",
                "Inventory management",
                "Payment tracking",
                "GST compliance & reporting",
                "Expense management"
            ],
            sidebarTitle: "Business Management",
            sidebarDescription: "Simplify invoicing, inventory, payments, and GST compliance with one powerful platform designed for Indian SMEs.",
            websiteUrl: "https://www.assistbuddi.com/business-management"
        },
        {
            title: "Project Management",
            icon: (
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                    <polyline points="14 2 14 8 20 8" />
                    <line x1="16" y1="13" x2="8" y2="13" />
                    <line x1="16" y1="17" x2="8" y2="17" />
                    <polyline points="10 9 9 9 8 9" />
                </svg>
            ),
            benefit: "Manage projects, tasks, and teams from one central hub with real-time collaboration",
            features: [
                "Central project management hub",
                "Real-time team collaboration",
                "Task tracking & assignment",
                "Progress monitoring",
                "Timeline & milestone tracking"
            ],
            sidebarTitle: "Project Management",
            sidebarDescription: "Manage projects, tasks, and teams from one central hub — track progress, collaborate in real-time, and deliver projects faster with Task Buddi's all-in-one project management and team collaboration platform.",
            websiteUrl: "https://www.assistbuddi.com/project-management"
        },
        {
            title: "WhatsApp Solution",
            icon: (
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
                </svg>
            ),
            benefit: "WhatsApp automation for marketing, lead capture, and CRM integration",
            features: [
                "WhatsApp marketing automation",
                "Chat flow management",
                "Lead capture & CRM integration",
                "Broadcast messaging",
                "Analytics-driven results"
            ],
            sidebarTitle: "WhatsApp Solution",
            sidebarDescription: "Empower your business with WhatsApp automation — from marketing campaigns and chat flows to lead capture and CRM integration. Reach customers instantly and simplify communication with analytics-driven results.",
            websiteUrl: "https://www.assistbuddi.com/whatsapp-solution"
        },
        {
            title: "Authentication",
            icon: (
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                </svg>
            ),
            benefit: "One-tap WhatsApp login, OTP-less access, and link-based verification",
            features: [
                "One-tap WhatsApp login",
                "OTP-less access",
                "Link-based verification",
                "Enterprise-grade security",
                "Frictionless user experience"
            ],
            sidebarTitle: "Authentication",
            sidebarDescription: "Enable one-tap WhatsApp login, OTP-less access, and link-based verification — all with enterprise-grade security and a frictionless user experience.",
            websiteUrl: "https://www.assistbuddi.com/authentication"
        },
        {
            title: "Voice Based Solution",
            icon: (
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z" />
                    <path d="M19 10v2a7 7 0 0 1-14 0v-2" />
                    <line x1="12" y1="19" x2="12" y2="23" />
                    <line x1="8" y1="23" x2="16" y2="23" />
                </svg>
            ),
            benefit: "AI-powered voice automation for ticketing, analytics, and omnichannel support",
            features: [
                "AI-powered voice automation",
                "Smart ticketing system",
                "Real-time agent assistance",
                "Omnichannel support integration",
                "Voice analytics dashboard",
            ],
            sidebarTitle: "Voice Based Solution",
            sidebarDescription: "Deliver smarter conversations with AI-powered voice automation. From ticketing and analytics to real-time agent assistance and omnichannel support — empower your business to engage, resolve, and delight customers with intelligent voice interactions.",
            websiteUrl: "https://www.assistbuddi.com/voice-solution"
        },
        {
            title: "Construction Management",
            icon: (
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="2" y="5" width="20" height="14" rx="2" />
                    <line x1="8" y1="5" x2="8" y2="19" />
                    <line x1="16" y1="5" x2="16" y2="19" />
                    <line x1="5" y1="12" x2="19" y2="12" />
                </svg>
            ),
            benefit: "End-to-end construction project management from planning to completion",
            features: [
                "Project planning & scheduling",
                "Resource & material tracking",
                "Budget & cost management",
                "Contractor & vendor management",
                "Progress reporting & analytics"
            ],
            sidebarTitle: "Construction Management",
            sidebarDescription: "Streamline your construction projects with comprehensive management tools. From initial planning and resource allocation to budget tracking and contractor management — deliver projects on time and within budget.",
            websiteUrl: "https://www.assistbuddi.com/construction-management"
        },
        {
            title: "Event Management",
            icon: (
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                    <line x1="16" y1="2" x2="16" y2="6" />
                    <line x1="8" y1="2" x2="8" y2="6" />
                    <line x1="3" y1="10" x2="21" y2="10" />
                    <circle cx="12" cy="15" r="1" />
                    <circle cx="16" cy="15" r="1" />
                    <circle cx="8" cy="15" r="1" />
                </svg>
            ),
            benefit: "Complete event planning, ticketing, and attendee management platform",
            features: [
                "Event planning & scheduling",
                "Online ticketing system",
                "Attendee management",
                "Venue & vendor coordination",
                "Real-time event analytics"
            ],
            sidebarTitle: "Event Management",
            sidebarDescription: "Plan and execute successful events with our comprehensive event management platform. From ticketing and attendee registration to vendor coordination and real-time analytics — make every event memorable.",
            websiteUrl: "https://www.assistbuddi.com/event-management"
        }
    ];

    // Simple Shiksha Products Data - 2 cards (SMS and LMS)
    const simpleShikshaProducts = [
        {
            title: "Simple Shiksha - SMS",
            category: "School Management System",
            icon: (
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M22 10v6M2 10l10-5 10 5-10 5z" />
                    <path d="M6 12v5c3 2 6 2 9 0v-5" />
                    <rect x="3" y="3" width="18" height="18" rx="2" />
                </svg>
            ),
            benefit: "A complete digital solution to manage daily school operations, streamline administration, and improve communication between staff, students, and parents.",
            features: [
                "Student admission & enrollment",
                "Fee tracking & management",
                "Parent-teacher communication portal",
                "Attendance management system",
                "Exam & grade management",
                "Transport management",
                "Library management",
                "Payroll & HR management"
            ],
            sidebarTitle: "Simple Shiksha - SMS",
            sidebarDescription: "A powerful school management system designed to simplify and automate institutional workflows. From admissions and attendance to finance and reporting, manage everything efficiently in one centralized platform.",
            websiteUrl: "https://school.simpleshiksha.in/"
        },
        {
            title: "Simple Shiksha - LMS",
            category: "Learning Management System",
            icon: (
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M12 6v7m0 0v7m0-7h7m-7 0H5" />
                    <circle cx="12" cy="12" r="10" />
                    <path d="M12 2a15 15 0 0 0 0 20 15 15 0 0 0 0-20z" />
                </svg>
            ),
            benefit: "A flexible learning platform to create, deliver, and manage courses while tracking learner engagement and performance at scale.",
            features: [
                "Course builder & content management",
                "Exams & assessments",
                "AI learning assistant",
                "Analytics dashboard",
                "Live discussions & forums",
                "Mobile & web platform",
                "Certification management",
                "Student progress tracking"
            ],
            sidebarTitle: "Simple Shiksha - LMS",
            sidebarDescription: "A modern LMS built for educators, businesses, and training institutes to deliver impactful learning experiences. Easily manage courses, track performance, and engage learners through interactive tools and real-time insights.",
            websiteUrl: "https://simpleshiksha.com/"
        }
    ];

    // WhatsApp contact info
    const whatsappNumber = "918084378326";
    const whatsappMessage = "Hello%20I%27m%20interested%20in%20your%20products.%20Can%20you%20please%20share%20more%20details%3F";
    const demoMessage = "Hello%20I%27d%20like%20to%20book%20a%20demo%20for%20your%20products.%20Can%20you%20please%20share%20more%20details%3F";
    const enquireMessage = "Hello%20I%27d%20like%20to%20enquire%20about%20your%20products.%20Can%20you%20please%20share%20more%20details%3F";

    // WhatsApp URLs
    const whatsappContactUrl = `https://wa.me/${whatsappNumber}?text=${whatsappMessage}`;
    const whatsappDemoUrl = `https://wa.me/${whatsappNumber}?text=${demoMessage}`;
    const whatsappEnquireUrl = `https://wa.me/${whatsappNumber}?text=${enquireMessage}`;

    // ========== STATE FOR SIDEBAR ==========
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState(null);

    // ========== REFS FOR SCROLLING ==========
    const productsSectionRef = useRef(null);

    // ========== FUNCTIONS ==========

    // Smooth scroll to products section
    const scrollToProducts = (e) => {
        e.preventDefault(); // Prevent default anchor behavior
        if (productsSectionRef.current) {
            const targetPosition = productsSectionRef.current.offsetTop;
            const startPosition = window.pageYOffset;
            const distance = targetPosition - startPosition;
            let startTime = null;

            const animation = (currentTime) => {
                if (startTime === null) startTime = currentTime;
                const timeElapsed = currentTime - startTime;
                const run = easeOutCubic(Math.min(timeElapsed, 800) / 800);
                window.scrollTo(0, startPosition + distance * run);
                if (timeElapsed < 800) requestAnimationFrame(animation);
            };

            requestAnimationFrame(animation);
        }
    };

    // Easing function for smooth scroll
    const easeOutCubic = (t) => {
        return 1 - Math.pow(1 - t, 3);
    };

    // Open sidebar with product details
    const openReadMore = (productData) => {
        setSelectedProduct({
            title: productData.sidebarTitle,
            description: productData.sidebarDescription,
            features: productData.features,
            websiteUrl: productData.websiteUrl
        });
        setIsSidebarOpen(true);
    };

    // Close sidebar
    const closeSidebar = () => {
        setIsSidebarOpen(false);
        setSelectedProduct(null);
    };

    // Handle explore from sidebar
    const handleSidebarExplore = () => {
        if (selectedProduct && selectedProduct.websiteUrl) {
            window.open(selectedProduct.websiteUrl, '_blank');
            closeSidebar();
        }
    };

    // ========== RENDER ==========

    return (
        <div className="product-page">
            {/* ========== SIDEBAR COMPONENT ========== */}
            <div className={`product-sidebar-overlay ${isSidebarOpen ? 'active' : ''}`} onClick={closeSidebar}>
                <div className={`product-sidebar ${isSidebarOpen ? 'open' : ''}`} onClick={(e) => e.stopPropagation()}>


                    {selectedProduct && (
                        <div className="sidebar-content">
                            <div className="sidebar-header">
                                <button onClick={closeSidebar}> <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <line x1="18" y1="6" x2="6" y2="18" />
                                    <line x1="6" y1="6" x2="18" y2="18" />
                                </svg></button>
                                <h2 className="sidebar-title">{selectedProduct.title}</h2>
                                <p className="sidebar-description">{selectedProduct.description}</p>
                            </div>

                            <div className="sidebar-features">
                                <h3 className="features-title">Key Features</h3>
                                <ul className="features-list">
                                    {selectedProduct.features.map((feature, idx) => (
                                        <li key={idx}>
                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                <polyline points="20 6 9 17 4 12" />
                                            </svg>
                                            {feature}
                                        </li>
                                    ))}
                                </ul>
                            </div>

                            {/* Button at the bottom - scrolls with content for ALL products */}
                            <div className="sidebar-bottom">
                                <a
                                    href={selectedProduct.websiteUrl}
                                    className="sidebar-explore-btn"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label={`Visit ${selectedProduct.title} website`}
                                >
                                    Start For Free →
                                </a>
                            </div>
                        </div>
                    )}
                </div>
            </div>

            {/* ========== HERO SECTION START ========== */}
            <section className="hero-section">
                <div className="container hero-container pt-5">
                    <h1 className="hero-title">Our Products</h1>
                    <p className="hero-description">
                        Powerful software solutions designed to help businesses operate, manage, and grow.
                    </p>
                    <div className="hero-buttons">
                        <a
                            href={whatsappEnquireUrl}
                            className="btn btn-primary btn-arrow"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Enquire now via WhatsApp"
                        >
                            Enquire Now <span className="arrow">→</span>
                        </a>
                    </div>
                    <a
                        href="#products-section"
                        className="hero-arrow-down"
                        onClick={scrollToProducts}
                        aria-label="Scroll to products"
                    >
                        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <polyline points="6 9 12 15 18 9"></polyline>
                        </svg>
                    </a>
                </div>
            </section>
            {/* ========== HERO SECTION END ========== */}

            {/* ========== ASSIST BUDDI DETAIL SECTION START ========== */}
            <section className="section primary-section" id="products-section" ref={productsSectionRef}>
                <div className="container">
                    <div className="section-header">
                        <h2 className="section-title">Assist Buddi</h2>
                        <span className="product-tag">Business Operations Platform</span>
                        <p className="section-description">
                            A complete platform to manage customer interactions, automate workflows, and streamline
                            business operations. From customer support to project management — everything your
                            business needs in one ecosystem.
                        </p>
                    </div>

                    <div className="modules-grid">
                        {assistBuddiModules.map((module, idx) => (
                            <div className="module-card" key={idx}>
                                <div className="module-icon">{module.icon}</div>
                                <h3 className="module-title">{module.title}</h3>
                                <p className="module-benefit">{module.benefit}</p>
                                <div className="module-buttons">
                                    <button
                                        className="card-btn-readmore"
                                        onClick={() => openReadMore(module)}
                                        aria-label={`Read more about ${module.title}`}
                                    >
                                        Read More
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
            {/* ========== ASSIST BUDDI DETAIL SECTION END ========== */}

            {/* ========== SIMPLE SHIKSHA SECTION START (2 CARDS) ========== */}
            <section className="product-detail-section">
                <div className="container">
                    <div className="section-header">
                        <h2 className="section-title">Simple Shiksha</h2>
                        <span className="product-tag">Ed-tech Operation Platform</span>
                        <p className="section-description">
                            Complete educational technology solutions for schools, colleges, and training institutions.
                            From school management to online learning — we have you covered.
                        </p>
                    </div>

                    <div className="simple-shiksha-grid">
                        {simpleShikshaProducts.map((product, idx) => (
                            <div className="simple-shiksha-card" key={idx}>
                                <div className="simple-shiksha-card-icon">{product.icon}</div>
                                <div className="simple-shiksha-card-badge">{product.category}</div>
                                <h3 className="simple-shiksha-card-title">{product.title}</h3>
                                <p className="simple-shiksha-card-benefit">{product.benefit}</p>
                                <button
                                    className="simple-shiksha-readmore-btn"
                                    onClick={() => openReadMore(product)}
                                    aria-label={`Read more about ${product.title}`}
                                >
                                    Read More →
                                </button>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
            {/* ========== SIMPLE SHIKSHA SECTION END ========== */}

            {/* ========== FINAL CTA SECTION START ========== */}
            <section className="final-cta-section">
                <div className="container">
                    <h3 className="final-cta-title">Ready to get started with our solutions?</h3>
                    <div className="final-cta-buttons">

                        <a
                            href={whatsappContactUrl}
                            className="cta-btn"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Contact us on WhatsApp"
                        >
                            Book a Demo 
                        </a>
                    </div>
                </div>
            </section>
            {/* ========== FINAL CTA SECTION END ========== */}
        </div>
    );
};

export default ProductPage;